<template>
    <div class="tag-input my-2 p-3">
        <vue-tags-input
            :add-on-key="[9, 13, ';']"
            :allow-edit-tags="true"
            :placeholder="placeholder || 'Add...'"
            v-model="tag"
            :tags="tags"
            :autocomplete-items="autocompleteItems"
            @tags-changed="onChange"
            :disabled="disabled"
        />
    </div>
</template>

<script>
export default {
    props: {
        disabled: {
            type: Boolean,
            required: false,
        },
        placeholder: {
            type    : String,
            required: false,
        },
        current: {
            type: Array,
            required: false,
        },
        suggestions: {
            type: Function,
            required: false,
        }
    },
    data() {
        return {
            tag              : '',
            tags             : this.make(this.current),
            autocompleteItems: [],
            debounce         : null,
        }
    },
    watch: {
        current(tags) {
            this.tags = this.make(tags);
        },
        tag: 'watchTag',
    },
    methods: {
        onChange(newTags) {
            this.tags = newTags
            this.$emit('change', newTags.map(tag => tag.text));
        },
        make(tags) {
            return tags.map(tag => {
                return {text: tag};
            });
        },
        watchTag() {
            if (this.tag.length < 2 || !this.suggestions) return;

            clearTimeout(this.debounce);
            this.debounce = setTimeout(() => {
                this.suggestions(this.tag, suggestions => {
                    this.autocompleteItems = this.make(suggestions)
                });
            }, 600);

            return [];
        }
    }
}
</script>

<style lang="scss" scoped>
    .vue-tags-input {
        background: transparent;
    }
</style>
